import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarSimpleRightWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sidebar-simple-right-wide"} maskId="square-filled-radius-0-stroke-1-IconSidebarSimpleRightWide"><path fillRule="evenodd" clipRule="evenodd" d="M22 4H2V20H22V4ZM16 5V19H3V5H16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSidebarSimpleRightWide;
